import React from 'react';
import { TEMPLATE_APPROVAL_LABELS } from '@claimup/shared/constants/kapsoTemplates';

/**
 * Los dos avisos de una plantilla, que miden cosas distintas y no hay que
 * mezclar:
 *
 * - **estado**: qué dice Meta de ella.
 * - **sync**: si lo que Meta aprobó sigue siendo lo que se enviaría.
 */

// Solo el color. El texto sale de `libs/shared`, que es de donde lo saca
// también el backend: escribirlo aquí otra vez es garantizar que un día digan
// cosas distintas.
const COLORES = {
  draft: 'bg-slate-100 text-slate-600',
  proposed: 'bg-sky-100 text-sky-700',
  declined: 'bg-orange-100 text-orange-700',
  pending: 'bg-amber-100 text-amber-700',
  approved: 'bg-emerald-100 text-emerald-700',
  rejected: 'bg-red-100 text-red-700',
  disabled: 'bg-red-100 text-red-700',
};

export const EstadoBadge = ({ estado, label }) => {
  const texto = TEMPLATE_APPROVAL_LABELS[estado] || label || estado;
  const clases = COLORES[estado] || 'bg-slate-100 text-slate-600';
  return (
    <span className={`px-2 py-0.5 rounded-lg text-[11px] font-medium ${clases}`}>{texto}</span>
  );
};

/**
 * `unknown` existe a propósito: decir «sincronizada» sin constancia de contra
 * qué texto se aprobó sería afirmar algo que no sabemos. Y `ok` no se enseña —
 * lo normal no necesita etiqueta.
 */
export const SyncBadge = ({ sync }) => {
  if (sync === 'ok') return null;
  if (sync === 'stale') {
    return (
      <span
        className='px-2 py-0.5 rounded-lg text-[11px] font-medium bg-red-100 text-red-700'
        title='El texto cambió después de que Meta lo aprobara: la aprobación ya no cubre lo que se enviaría'
      >
        Aprobación desfasada
      </span>
    );
  }
  return (
    <span
      className='px-2 py-0.5 rounded-lg text-[11px] font-medium bg-slate-100 text-slate-500'
      title='No consta contra qué texto se aprobó'
    >
      Sin constancia
    </span>
  );
};

/** El catálogo se movió después de añadirla. Su aprobación sigue siendo válida. */
export const DriftBadge = ({ drift }) =>
  drift ? (
    <span
      className='px-2 py-0.5 rounded-lg text-[11px] font-medium bg-blue-50 text-blue-700'
      title='El catálogo cambió después de añadirla. No se propaga solo: propagarlo obligaría a pasar otra vez por Meta'
    >
      Catálogo actualizado
    </span>
  ) : null;
